import type { FC } from 'react';
import { Box, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const LaunchedStatusIcon: FC<{ launched: boolean }> = ({ launched }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
    <Tooltip title={launched ? 'Launched' : 'Not launched'}>
      {launched ? (
        <CheckCircleIcon color="success" fontSize="small" titleAccess="Launched" />
      ) : (
        <RadioButtonUncheckedIcon color="disabled" fontSize="small" titleAccess="Not launched" />
      )}
    </Tooltip>
  </Box>
);

export default LaunchedStatusIcon;
